import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VCalendar from 'v-calendar';
import {func} from './func.js'
import Skeleton from 'vue-loading-skeleton';
 
Vue.use(Skeleton)

Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

Vue.config.productionTip = false

Vue.prototype.$func = func

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

